import axios from "axios";
import { apiVariable } from "./apiVariable";
import { OperationsPlannerGrossReportDto } from "../interfaces/Operations/operationsPlannerGrossReport";

const endpoint = `${apiVariable}/getOperationsPlannerGrossReport`;

export const fetchOperationsPlannerGrossReport = async (
  token: string | null | undefined,
  date?: string
): Promise<OperationsPlannerGrossReportDto> => {
  if (!token) {
    throw new Error("Missing authentication token");
  }

  const response = await axios.get<OperationsPlannerGrossReportDto>(endpoint, {
    params: { date },
    headers: {
      Authorization: `Bearer ${token}`,
    },
  });

  return response.data;
};
